let llamarPopPremium = function() {
	let t = this;
	t.$store.commit('core/session/setShowPopPremium', {show: false, data: []});
	setTimeout(function(){t.$store.commit('core/session/setShowPopPremium', {show: true, data: []});}, 500);
};
export default llamarPopPremium;
